type CheckIsValidPercentProps = {
  percent: number;
  actualPercent: number;
};

export const checkIsValidPercent = ({
  percent,
  actualPercent,
}: CheckIsValidPercentProps): boolean => {
  const isValidPercent = percent + actualPercent <= 100;
  const isPositivePercent = percent > 0;

  return isValidPercent && isPositivePercent;
};
